<template>
  <div v-loading="loading" class="prospectus-container">
    <div class="page-header-container">
      <div class="header-title">
        <span class="title-text">{{ headerTitle }}</span>
        <span class="file-link" >
          <el-tag>
            <a target="_blank" :href="fileUrl">查看原始文件</a>
          </el-tag>
        </span>
      </div>
    </div>
    <div v-if="!loading & canEdit && reportType === 'prospectus'" class="insert-action">
      <el-button
        type="primary"
        size="small"
        icon="el-icon-finished"
        @click="insertToDb"
      >
        数据入库
      </el-button>
    </div>
    <div v-if="!loading && reportType === 'asset_pool' && this.hasAssetPoolError" class="error-header">
      <el-alert
        title="可能存在底稿错误"
        type="error"
        :closable="false"
        show-icon
      />
    </div>
    <div ref="assetPoolToolBar">
      <div v-if="!loading & canEdit && reportType === 'asset_pool'" :class="fixedToolBarClass">
        <el-button type="primary" size="small" @click="onClickEditAssetPoolConfig('field_index_mapping')">修改识别统计字段</el-button>
        <el-button type="primary" size="small" @click="onClickEditAssetPoolConfig('format_mode')">修改分布统计设置</el-button>
        <el-button v-if="hasAssetPoolError" type="primary" size="small" @click="onClickAssetPoolError">可能存在的底稿错误</el-button>
      </div>
    </div>
    <div v-if="canView" style="margin-top:15px;" class="result-container">
      <div class="result">
        <div class="left menu-view" ref="menuTree">
          <div class="menu-tree" :class="fixedMenuClass">
            <div class="menu-tree-wrapper">
              <el-tree
                ref="elMenuTree"
                :data="menuTree"
                @node-click="handleNodeClick"
              >
              </el-tree>
            </div>
          </div>
        </div>
        <div class="middle">
<!--          todo 排除更多类型-->
          <div v-if="reportType !== 'asset_pool'" class="errors-container">
            <vxe-table
              ref="showErrors"
              size="mini"
              auto-resize
              sync-resize
              border
              :max-height="300"
              :data="errors"
            >
              <vxe-table-column field="error_info" min-width="300" title="勾稽关系错误" header-align="center" />
              <vxe-table-column min-width="500" title="相关科目" header-align="center">
                <template v-slot="{ row }">
                  <div class="fields-container">
                    <div v-for="field in row.error_fields" class="field-wrapper">
                      <div
                        class="field-cross-tables"
                        :class="{'can-jump': field.canLocate === true, 'cannot-jump': field.canLocate === false}"
                        @click="jumpToField(field.name)"
                      >
                        {{ field.view }}
                      </div>
                    </div>
                  </div>
                </template>
              </vxe-table-column>
            </vxe-table>
          </div>
          <div v-for="(field) in list" :key="field.key">
            <div class="field-bar">
              <span :id="`${field.key}`" :class="fieldPlaceholderClass"></span>
              <span class="field-title">{{ field.col0 }}</span>
              <el-button size="small" @click="editEvent(field)">编辑</el-button>
              <el-button v-if="canEditRange(field.col0)"
                         size="small" @click="modifyDistribution(field)">修改区间</el-button>
              <!--              <el-button size="small" @click="gotoPage(field)">跳转</el-button>-->
            </div>
            <div v-if="field.col1">
              <div class="field-content" v-html="field.col1" />
            </div>
            <div v-else>
              <div class="field-content">无</div>
            </div>
          </div>
          <!--          <vxe-table-->
          <!--            ref="xTable"-->
          <!--            size="mini"-->
          <!--            class="html-table"-->
          <!--            border-->
          <!--            keep-source-->
          <!--            :cell-style="htmlCellStyle"-->
          <!--            :loading="loading"-->
          <!--            :data="list"-->
          <!--            :show-header="false"-->
          <!--          >-->
          <!--            <vxe-table-column class="key" field="col0" width="180">-->
          <!--              <template v-slot="{ row }">-->
          <!--                <div :id="row.key" class="html-key">-->
          <!--                  <div class="key">{{ row.col0 }}</div>-->
          <!--                  <div v-if="row.deadline !== '' && row.deadline !== undefined" class="deadline">-->
          <!--                    <span class="title">截止日</span>-->
          <!--                    <span class="date">{{ row.deadline }}</span>-->
          <!--                  </div>-->
          <!--                </div>-->
          <!--              </template>-->
          <!--            </vxe-table-column>-->
          <!--            <vxe-table-column field="col1" type="html" width="650" title="值" :edit-render="{name: 'input', immediate: true, attrs: {type: 'html'}}">-->
          <!--              <template v-slot="{ row, rowIndex, columnIndex}">-->
          <!--                <div :id="`field-${rowIndex}-${columnIndex}`" v-html="row.col1" />-->
          <!--              </template>-->
          <!--            </vxe-table-column>-->
          <!--            <vxe-table-column v-if="canEdit" title="操作" width="100" show-overflow>-->
          <!--              <template v-slot="{ row }">-->
          <!--                <div class="html-action">-->
          <!--                  &lt;!&ndash;          <vxe-button type="text" icon="fa fa-edit" @click="editEvent(row)"></vxe-button>&ndash;&gt;-->
          <!--                  <el-button :class="row.col1 === '' ? 'empty-html-action' : '' " type="primary" size="small" @click="editEvent(row)">编辑</el-button>-->
          <!--                </div>-->
          <!--              </template>-->
          <!--            </vxe-table-column>-->
          <!--          </vxe-table>-->
        </div>
      </div>
    </div>
    <div v-else>
      <div class="result-container">
        <svg width="251" height="294"><g fill="none" fill-rule="evenodd"><path d="M0 129.023v-2.084C0 58.364 55.591 2.774 124.165 2.774h2.085c68.574 0 124.165 55.59 124.165 124.165v2.084c0 68.575-55.59 124.166-124.165 124.166h-2.085C55.591 253.189 0 197.598 0 129.023" fill="#E4EBF7" /><path d="M41.417 132.92a8.231 8.231 0 1 1-16.38-1.65 8.231 8.231 0 0 1 16.38 1.65" fill="#FFF" /><path d="M38.652 136.36l10.425 5.91M49.989 148.505l-12.58 10.73" stroke="#FFF" stroke-width="2" /><path d="M41.536 161.28a5.636 5.636 0 1 1-11.216-1.13 5.636 5.636 0 0 1 11.216 1.13M59.154 145.261a5.677 5.677 0 1 1-11.297-1.138 5.677 5.677 0 0 1 11.297 1.138M100.36 29.516l29.66-.013a4.562 4.562 0 1 0-.004-9.126l-29.66.013a4.563 4.563 0 0 0 .005 9.126M111.705 47.754l29.659-.013a4.563 4.563 0 1 0-.004-9.126l-29.66.013a4.563 4.563 0 1 0 .005 9.126" fill="#FFF" /><path d="M114.066 29.503V29.5l15.698-.007a4.563 4.563 0 1 0 .004 9.126l-15.698.007v-.002a4.562 4.562 0 0 0-.004-9.122M185.405 137.723c-.55 5.455-5.418 9.432-10.873 8.882-5.456-.55-9.432-5.418-8.882-10.873.55-5.455 5.418-9.432 10.873-8.882 5.455.55 9.432 5.418 8.882 10.873" fill="#FFF" /><path d="M180.17 143.772l12.572 7.129M193.841 158.42L178.67 171.36" stroke="#FFF" stroke-width="2" /><path d="M185.55 171.926a6.798 6.798 0 1 1-13.528-1.363 6.798 6.798 0 0 1 13.527 1.363M204.12 155.285a6.848 6.848 0 1 1-13.627-1.375 6.848 6.848 0 0 1 13.626 1.375" fill="#FFF" /><path d="M152.988 194.074a2.21 2.21 0 1 1-4.42 0 2.21 2.21 0 0 1 4.42 0zM225.931 118.217a2.21 2.21 0 1 1-4.421 0 2.21 2.21 0 0 1 4.421 0zM217.09 153.051a2.21 2.21 0 1 1-4.421 0 2.21 2.21 0 0 1 4.42 0zM177.84 109.842a2.21 2.21 0 1 1-4.422 0 2.21 2.21 0 0 1 4.421 0zM196.114 94.454a2.21 2.21 0 1 1-4.421 0 2.21 2.21 0 0 1 4.421 0zM202.844 182.523a2.21 2.21 0 1 1-4.42 0 2.21 2.21 0 0 1 4.42 0z" stroke="#FFF" stroke-width="2" /><path stroke="#FFF" stroke-width="2" d="M215.125 155.262l-1.902 20.075-10.87 5.958M174.601 176.636l-6.322 9.761H156.98l-4.484 6.449M175.874 127.28V111.56M221.51 119.404l-12.77 7.859-15.228-7.86V96.668" /><path d="M180.68 29.32C180.68 13.128 193.806 0 210 0c16.193 0 29.32 13.127 29.32 29.32 0 16.194-13.127 29.322-29.32 29.322-16.193 0-29.32-13.128-29.32-29.321" fill="#A26EF4" /><path d="M221.45 41.706l-21.563-.125a1.744 1.744 0 0 1-1.734-1.754l.071-12.23a1.744 1.744 0 0 1 1.754-1.734l21.562.125c.964.006 1.74.791 1.735 1.755l-.071 12.229a1.744 1.744 0 0 1-1.754 1.734" fill="#FFF" /><path d="M215.106 29.192c-.015 2.577-2.049 4.654-4.543 4.64-2.494-.014-4.504-2.115-4.489-4.693l.04-6.925c.016-2.577 2.05-4.654 4.543-4.64 2.494.015 4.504 2.116 4.49 4.693l-.04 6.925zm-4.53-14.074a6.877 6.877 0 0 0-6.916 6.837l-.043 7.368a6.877 6.877 0 0 0 13.754.08l.042-7.368a6.878 6.878 0 0 0-6.837-6.917zM167.566 68.367h-3.93a4.73 4.73 0 0 1-4.717-4.717 4.73 4.73 0 0 1 4.717-4.717h3.93a4.73 4.73 0 0 1 4.717 4.717 4.73 4.73 0 0 1-4.717 4.717" fill="#FFF" /><path d="M168.214 248.838a6.611 6.611 0 0 1-6.61-6.611v-66.108a6.611 6.611 0 0 1 13.221 0v66.108a6.611 6.611 0 0 1-6.61 6.61" fill="#5BA02E" /><path d="M176.147 248.176a6.611 6.611 0 0 1-6.61-6.61v-33.054a6.611 6.611 0 1 1 13.221 0v33.053a6.611 6.611 0 0 1-6.61 6.611" fill="#92C110" /><path d="M185.994 293.89h-27.376a3.17 3.17 0 0 1-3.17-3.17v-45.887a3.17 3.17 0 0 1 3.17-3.17h27.376a3.17 3.17 0 0 1 3.17 3.17v45.886a3.17 3.17 0 0 1-3.17 3.17" fill="#F2D7AD" /><path d="M81.972 147.673s6.377-.927 17.566-1.28c11.729-.371 17.57 1.086 17.57 1.086s3.697-3.855.968-8.424c1.278-12.077 5.982-32.827.335-48.273-1.116-1.339-3.743-1.512-7.536-.62-1.337.315-7.147-.149-7.983-.1l-15.311-.347s-3.487-.17-8.035-.508c-1.512-.113-4.227-1.683-5.458-.338-.406.443-2.425 5.669-1.97 16.077l8.635 35.642s-3.141 3.61 1.219 7.085" fill="#FFF" /><path d="M75.768 73.325l-.9-6.397 11.982-6.52s7.302-.118 8.038 1.205c.737 1.324-5.616.993-5.616.993s-1.836 1.388-2.615 2.5c-1.654 2.363-.986 6.471-8.318 5.986-1.708.284-2.57 2.233-2.57 2.233" fill="#FFC6A0" /><path d="M52.44 77.672s14.217 9.406 24.973 14.444c1.061.497-2.094 16.183-11.892 11.811-7.436-3.318-20.162-8.44-21.482-14.496-.71-3.258 2.543-7.643 8.401-11.76M141.862 80.113s-6.693 2.999-13.844 6.876c-3.894 2.11-10.137 4.704-12.33 7.988-6.224 9.314 3.536 11.22 12.947 7.503 6.71-2.651 28.999-12.127 13.227-22.367" fill="#FFB594" /><path d="M76.166 66.36l3.06 3.881s-2.783 2.67-6.31 5.747c-7.103 6.195-12.803 14.296-15.995 16.44-3.966 2.662-9.754 3.314-12.177-.118-3.553-5.032.464-14.628 31.422-25.95" fill="#FFC6A0" /><path d="M64.674 85.116s-2.34 8.413-8.912 14.447c.652.548 18.586 10.51 22.144 10.056 5.238-.669 6.417-18.968 1.145-20.531-.702-.208-5.901-1.286-8.853-2.167-.87-.26-1.611-1.71-3.545-.936l-1.98-.869zM128.362 85.826s5.318 1.956 7.325 13.734c-.546.274-17.55 12.35-21.829 7.805-6.534-6.94-.766-17.393 4.275-18.61 4.646-1.121 5.03-1.37 10.23-2.929" fill="#FFF" /><path d="M78.18 94.656s.911 7.41-4.914 13.078" stroke="#E4EBF7" stroke-width="1.051" stroke-linecap="round" stroke-linejoin="round" /><path d="M87.397 94.68s3.124 2.572 10.263 2.572c7.14 0 9.074-3.437 9.074-3.437" stroke="#E4EBF7" stroke-width=".932" stroke-linecap="round" stroke-linejoin="round" /><path d="M117.184 68.639l-6.781-6.177s-5.355-4.314-9.223-.893c-3.867 3.422 4.463 2.083 5.653 4.165 1.19 2.082.848 1.143-2.083.446-5.603-1.331-2.082.893 2.975 5.355 2.091 1.845 6.992.955 6.992.955l2.467-3.851z" fill="#FFC6A0" /><path d="M105.282 91.315l-.297-10.937-15.918-.027-.53 10.45c-.026.403.17.788.515.999 2.049 1.251 9.387 5.093 15.799.424.287-.21.443-.554.431-.91" fill="#FFB594" /><path d="M107.573 74.24c.817-1.147.982-9.118 1.015-11.928a1.046 1.046 0 0 0-.965-1.055l-4.62-.365c-7.71-1.044-17.071.624-18.253 6.346-5.482 5.813-.421 13.244-.421 13.244s1.963 3.566 4.305 6.791c.756 1.041.398-3.731 3.04-5.929 5.524-4.594 15.899-7.103 15.899-7.103" fill="#5C2552" /><path d="M88.426 83.206s2.685 6.202 11.602 6.522c7.82.28 8.973-7.008 7.434-17.505l-.909-5.483c-6.118-2.897-15.478.54-15.478.54s-.576 2.044-.19 5.504c-2.276 2.066-1.824 5.618-1.824 5.618s-.905-1.922-1.98-2.321c-.86-.32-1.897.089-2.322 1.98-1.04 4.632 3.667 5.145 3.667 5.145" fill="#FFC6A0" /><path stroke="#DB836E" stroke-width="1.145" stroke-linecap="round" stroke-linejoin="round" d="M100.843 77.099l1.701-.928-1.015-4.324.674-1.406" /><path d="M105.546 74.092c-.022.713-.452 1.279-.96 1.263-.51-.016-.904-.607-.882-1.32.021-.713.452-1.278.96-1.263.51.016.904.607.882 1.32M97.592 74.349c-.022.713-.452 1.278-.961 1.263-.509-.016-.904-.607-.882-1.32.022-.713.452-1.279.961-1.263.51.016.904.606.882 1.32" fill="#552950" /><path d="M91.132 86.786s5.269 4.957 12.679 2.327" stroke="#DB836E" stroke-width="1.145" stroke-linecap="round" stroke-linejoin="round" /><path d="M99.776 81.903s-3.592.232-1.44-2.79c1.59-1.496 4.897-.46 4.897-.46s1.156 3.906-3.457 3.25" fill="#DB836E" /><path d="M102.88 70.6s2.483.84 3.402.715M93.883 71.975s2.492-1.144 4.778-1.073" stroke="#5C2552" stroke-width="1.526" stroke-linecap="round" stroke-linejoin="round" /><path d="M86.32 77.374s.961.879 1.458 2.106c-.377.48-1.033 1.152-.236 1.809M99.337 83.719s1.911.151 2.509-.254" stroke="#DB836E" stroke-width="1.145" stroke-linecap="round" stroke-linejoin="round" /><path d="M87.782 115.821l15.73-3.012M100.165 115.821l10.04-2.008" stroke="#E4EBF7" stroke-width="1.051" stroke-linecap="round" stroke-linejoin="round" /><path d="M66.508 86.763s-1.598 8.83-6.697 14.078" stroke="#E4EBF7" stroke-width="1.114" stroke-linecap="round" stroke-linejoin="round" /><path d="M128.31 87.934s3.013 4.121 4.06 11.785" stroke="#E4EBF7" stroke-width="1.051" stroke-linecap="round" stroke-linejoin="round" /><path d="M64.09 84.816s-6.03 9.912-13.607 9.903" stroke="#DB836E" stroke-width=".795" stroke-linecap="round" stroke-linejoin="round" /><path d="M112.366 65.909l-.142 5.32s5.993 4.472 11.945 9.202c4.482 3.562 8.888 7.455 10.985 8.662 4.804 2.766 8.9 3.355 11.076 1.808 4.071-2.894 4.373-9.878-8.136-15.263-4.271-1.838-16.144-6.36-25.728-9.73" fill="#FFC6A0" /><path d="M130.532 85.488s4.588 5.757 11.619 6.214" stroke="#DB836E" stroke-width=".75" stroke-linecap="round" stroke-linejoin="round" /><path d="M121.708 105.73s-.393 8.564-1.34 13.612" stroke="#E4EBF7" stroke-width="1.051" stroke-linecap="round" stroke-linejoin="round" /><path d="M115.784 161.512s-3.57-1.488-2.678-7.14" stroke="#648BD8" stroke-width="1.051" stroke-linecap="round" stroke-linejoin="round" /><path d="M101.52 290.246s4.326 2.057 7.408 1.03c2.842-.948 4.564.673 7.132 1.186 2.57.514 6.925 1.108 11.772-1.269-.104-5.551-6.939-4.01-12.048-6.763-2.582-1.39-3.812-4.757-3.625-8.863h-9.471s-1.402 10.596-1.169 14.68" fill="#CBD1D1" /><path d="M101.496 290.073s2.447 1.281 6.809.658c3.081-.44 3.74.485 7.479 1.039 3.739.554 10.802-.07 11.91-.9.415 1.108-.347 2.077-.347 2.077s-1.523.608-4.847.831c-2.045.137-5.843.293-7.663-.507-1.8-1.385-5.286-1.917-5.77-.243-3.947.958-7.41-.288-7.41-.288l-.16-2.667z" fill="#2B0849" /><path d="M108.824 276.19h3.116s-.103 6.751 4.57 8.62c-4.673.624-8.62-2.32-7.686-8.62" fill="#A4AABA" /><path d="M57.65 272.52s-2.122 7.47-4.518 12.396c-1.811 3.724-4.255 7.548 5.505 7.548 6.698 0 9.02-.483 7.479-6.648-1.541-6.164.268-13.296.268-13.296H57.65z" fill="#CBD1D1" /><path d="M51.54 290.04s2.111 1.178 6.682 1.178c6.128 0 8.31-1.662 8.31-1.662s.605 1.122-.624 2.18c-1 .862-3.624 1.603-7.444 1.559-4.177-.049-5.876-.57-6.786-1.177-.831-.554-.692-1.593-.138-2.078" fill="#2B0849" /><path d="M58.533 274.438s.034 1.529-.315 2.95c-.352 1.431-1.087 3.127-1.139 4.17-.058 1.16 4.57 1.592 5.194.035.623-1.559 1.303-6.475 1.927-7.306.622-.831-4.94-2.135-5.667.15" fill="#A4AABA" /><path d="M100.885 277.015l13.306.092s1.291-54.228 1.843-64.056c.552-9.828 3.756-43.13.997-62.788l-12.48-.64-22.725.776s-.433 3.944-1.19 9.921c-.062.493-.677.838-.744 1.358-.075.582.42 1.347.318 1.956-2.35 14.003-6.343 32.926-8.697 46.425-.116.663-1.227 1.004-1.45 2.677-.04.3.21 1.516.112 1.785-6.836 18.643-10.89 47.584-14.2 61.551l14.528-.014s2.185-8.524 4.008-16.878c2.796-12.817 22.987-84.553 22.987-84.553l3-.517 1.037 46.1s-.223 1.228.334 2.008c.558.782-.556 1.117-.39 2.233l.39 1.784s-.446 7.14-.892 11.826c-.446 4.685-.092 38.954-.092 38.954" fill="#7BB2F9" /><path d="M77.438 220.434c1.146.094 4.016-2.008 6.916-4.91M107.55 223.931s2.758-1.103 6.069-3.862" stroke="#648BD8" stroke-width="1.051" stroke-linecap="round" stroke-linejoin="round" /><path d="M108.459 220.905s2.759-1.104 6.07-3.863" stroke="#648BD8" stroke-linecap="round" stroke-linejoin="round" /><path d="M76.099 223.557s2.608-.587 6.47-3.346M87.33 150.82c-.27 3.088.297 8.478-4.315 9.073M104.829 149.075s.11 13.936-1.286 14.983c-2.207 1.655-2.975 1.934-2.975 1.934M101.014 149.63s.035 12.81-1.19 24.245M94.93 174.965s7.174-1.655 9.38-1.655M75.671 204.754c-.316 1.55-.64 3.067-.973 4.535 0 0-1.45 1.822-1.003 3.756.446 1.934-.943 2.034-4.96 15.273-1.686 5.559-4.464 18.49-6.313 27.447-.078.38-4.018 18.06-4.093 18.423M77.043 196.743a313.269 313.269 0 0 1-.877 4.729M83.908 151.414l-1.19 10.413s-1.091.148-.496 2.23c.111 1.34-2.66 15.692-5.153 30.267M57.58 272.94h13.238" stroke="#648BD8" stroke-width="1.051" stroke-linecap="round" stroke-linejoin="round" /><path d="M117.377 147.423s-16.955-3.087-35.7.199c.157 2.501-.002 4.128-.002 4.128s14.607-2.802 35.476-.31c.251-2.342.226-4.017.226-4.017" fill="#192064" /><path d="M107.511 150.353l.004-4.885a.807.807 0 0 0-.774-.81c-2.428-.092-5.04-.108-7.795-.014a.814.814 0 0 0-.784.81l-.003 4.88c0 .456.371.82.827.808a140.76 140.76 0 0 1 7.688.017.81.81 0 0 0 .837-.806" fill="#FFF" /><path d="M106.402 149.426l.002-3.06a.64.64 0 0 0-.616-.643 94.135 94.135 0 0 0-5.834-.009.647.647 0 0 0-.626.643l-.001 3.056c0 .36.291.648.651.64 1.78-.04 3.708-.041 5.762.012.36.009.662-.279.662-.64" fill="#192064" /><path d="M101.485 273.933h12.272M102.652 269.075c.006 3.368.04 5.759.11 6.47M102.667 263.125c-.009 1.53-.015 2.98-.016 4.313M102.204 174.024l.893 44.402s.669 1.561-.224 2.677c-.892 1.116 2.455.67.893 2.231-1.562 1.562.893 1.116 0 3.347-.592 1.48-.988 20.987-1.09 34.956" stroke="#648BD8" stroke-width="1.051" stroke-linecap="round" stroke-linejoin="round" /></g></svg>
        <div class="result-title">
          您没有权限查看当前项目
        </div>
      </div>
    </div>
    <el-dialog
      title="编辑"
      :visible.sync="editTextFieldDialogVisible"
    >
      <el-input v-model="text" placeholder="请输入内容"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editTextFieldDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="appendUploadLoading" @click="saveText">保存</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="编辑"
      :visible.sync="editHtmlFieldDialogVisible"
    >
      <tinymce v-model="html" :height="300" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="editHtmlFieldDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="appendUploadLoading" @click="saveHtml">保存</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="assetPoolDialogVisible"
      :before-close="resetAssetPoolForm"
      :title="assetPoolDialogTitleMap[assetPoolDialogKind]"
      width="700px"
      center
    >
      <div v-if="assetPoolDataLoading" v-loading="assetPoolDataLoading" style="height: 300px"></div>
      <div class="asset-pool-fields-container" v-if="!assetPoolDataLoading && assetPoolDialogKind === 'field_index_mapping'">
        <AssetPoolFieldMapper
          ref="assetPool"
          mode="update"
          :assetRefreshFlag="assetRefreshFlag"
          :projectId="projectId"
          :assetPoolData="assetPoolData"
          :field_index_mapping="field_index_mapping"
        />
        <div class="action-next-step">
          <el-button style="width: 150px" type="primary" :loading="assetPoolUpdateLoading" @click="onClickUpdateAssetPoolConfig">确认修改</el-button>
          <el-button style="width: 150px" @click="onClickCancelUpdateAssetPoolConfig">取消</el-button>
        </div>
      </div>
      <div class="asset-pool-fields-container" v-if="!assetPoolDataLoading && assetPoolDialogKind === 'format_mode'">
        <div class="asset-pool-field-wrapper">
          <div class="field-name-wrapper">
            <div class="field-name">区间开闭</div>
          </div>
          <div class="field-selector-wrapper">
            <div class="field-selector">
              <el-select style="width: 100%" @change="onFormatTypeChange" v-model="format_type" size="middle">
                <el-option value="左开右闭">左开右闭</el-option>
                <el-option value="左闭右开">左闭右开</el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="asset-pool-field-wrapper">
          <div class="field-name-wrapper">
            <div class="field-name">区间显示形式</div>
          </div>
          <div class="field-selector-wrapper">
            <div class="field-selector">
              <el-select style="width: 100%" v-model="format_mode" size="middle">
                <el-option v-if="format_type === '左开右闭'" label="a-b（含）" value="(a-b（含）]">a-b（含）</el-option>
                <el-option v-if="format_type === '左开右闭'" value="(a,b]">(a,b]</el-option>
                <el-option v-if="format_type === '左闭右开'" label="a（含）-b" value="[a（含）-b)">a（含）-b</el-option>
                <el-option v-if="format_type === '左闭右开'" value="[a,b)">[a,b)</el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="asset-pool-field-wrapper">
          <div class="field-name-wrapper">
            <div class="field-name">分布表格的单位</div>
          </div>
          <div class="field-selector-wrapper">
            <div class="field-selector">
              <el-select  style="width: 100%" v-model="unit" size="middle">
                <el-option value="元">元</el-option>
                <el-option value="万元">万元</el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="action-next-step">
          <el-button style="width: 150px" type="primary" :loading="assetPoolUpdateLoading" @click="onClickUpdateAssetPoolConfig">确认修改</el-button>
          <el-button style="width: 150px" @click="onClickCancelUpdateAssetPoolConfig">取消</el-button>
        </div>
      </div>
      <div v-if="!assetPoolDataLoading && assetPoolDialogKind === 'table_detail'">
        <div v-if="table_detail.field_name === '用户自选字段分布'" class="asset-pool-field-wrapper">
          <div class="field-name-wrapper">
            <div class="field-name">自选字段</div>
          </div>
          <div class="field-selector-wrapper">
            <div class="field-selector">
              <div>
                <el-select style="width: 100%" size="middle"
                           v-model="table_detail.self_selected_field_name"
                  @change="onTableDetailSelfSelectedFieldChange"
                >
                  <el-option
                    v-for="form in assetPoolData.current_user_define_form"
                    :key="form.form_name"
                    :label="form.form_name"
                    :value="form.form_name"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
        <div class="asset-pool-field-wrapper">
          <div class="field-name-wrapper">
            <div class="field-name">表格显示最小值</div>
          </div>
          <div class="field-selector-wrapper">
            <div class="field-selector">
              <div>
                <el-input
                  v-model="table_detail.min_num"
                >
                </el-input>
              </div>
              <div v-if="table_detail.min_num_hint !== ''" class="field-number-hint">
                提示：数据真实最小值：{{table_detail.min_num_hint}}
              </div>
            </div>
          </div>
        </div>
        <div class="asset-pool-field-wrapper">
          <div class="field-name-wrapper">
            <div class="field-name">表格显示最大值</div>
          </div>
          <div class="field-selector-wrapper">
            <div class="field-selector">
              <div>
                <el-input
                  v-model="table_detail.max_num"
                >
                </el-input>
              </div>
              <div v-if="table_detail.max_num_hint !== ''" class="field-number-hint">
                提示：数据真实最大值：{{table_detail.max_num_hint}}
              </div>
            </div>
          </div>
        </div>
        <div class="step-type-selector asset-pool-field-wrapper">
          <div class="field-name-wrapper"></div>
          <div class="field-selector-wrapper">
            <el-radio v-model="table_detail.isMultiSteps" :label="false">固定步长</el-radio>
            <el-radio v-model="table_detail.isMultiSteps" :label="true">自定义步长</el-radio>
          </div>
        </div>
        <div v-show="!table_detail.isMultiSteps" class="asset-pool-field-wrapper">
          <div class="field-name-wrapper">
            <div class="field-name">步长</div>
          </div>
          <div class="field-selector-wrapper">
            <div class="field-selector">
              <el-input
                v-model="table_detail.step"
              >
              </el-input>
            </div>
          </div>
        </div>
        <div v-show="table_detail.isMultiSteps" class="multi-steps asset-pool-field-wrapper">
          <div class="field-name-wrapper">
            <div class="field-name">步长</div>
          </div>
          <div class="content-box">
            <div class="section-area">
              <div class="section-item"
                   v-for="(item,index) in table_detail.multiSteps"
                   :key="index">
                <div class="area-input-box">
                  <div v-if="index===0"
                       style="width:80px;"></div>
                  <el-input-number v-else-if="index===1"
                                   v-model="item[0]"
                                   :max="item[1]"
                                   size="mini"
                                   @change="(val)=>itemLeftNumberChange(val,index)"></el-input-number>
                  <el-input-number v-else-if="index===table_detail.multiSteps.length-1"
                                   v-model="item[0]"
                                   :min="table_detail.multiSteps[index-1][0]"
                                   size="mini"
                                   @change="(val)=>itemLeftNumberChange(val,index)"></el-input-number>
                  <el-input-number v-else
                                   v-model="item[0]"
                                   :min="table_detail.multiSteps[index-1][0]"
                                   :max="item[1]"
                                   size="mini"
                                   @change="(val)=>itemLeftNumberChange(val,index)"></el-input-number>
                  <span v-if="index===0">小于</span>
                  <span v-else-if="index===table_detail.multiSteps.length-1">或以上</span>
                  <span v-else>至</span>
                  <div v-if="index===table_detail.multiSteps.length-1"
                       style="width:80px;"></div>
                  <el-input-number v-else-if="index===table_detail.multiSteps.length-2"
                                   v-model="item[1]"
                                   :min="item[0]"
                                   size="mini"
                                   @change="(val)=>itemRightNumberChange(val,index)"></el-input-number>
                  <el-input-number v-else-if="index===0"
                                   v-model="item[1]"
                                   :max="table_detail.multiSteps[index+1][1]"
                                   size="mini"
                                   @change="(val)=>itemRightNumberChange(val,index)"></el-input-number>
                  <el-input-number v-else
                                   v-model="item[1]"
                                   :min="item[0]"
                                   :max="table_detail.multiSteps[index+1][1]"
                                   size="mini"
                                   @change="(val)=>itemRightNumberChange(val,index)"></el-input-number>
                </div>
                <i class="el-icon-delete"
                   v-show="index!==0&&index!==table_detail.multiSteps.length-1"
                   @click="delArea(item,index)"></i>
              </div>
            </div>
            <div class="add-but"
                 @click="addArea">+ 新增区间</div>
          </div>
        </div>
        <div class="action-next-step">
          <el-button style="width: 150px" type="primary" :loading="assetPoolUpdateLoading" @click="onClickUpdateAssetPoolConfig">确认修改</el-button>
          <el-button style="width: 150px" @click="onClickCancelUpdateAssetPoolConfig">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="assetPoolErrorVisible"
      title="可能的底稿错误"
      width="900px"
      center
    >
      <div>
        <AssetPoolError
          :error="this.assetPoolError"
          kind="inDetail"
          @chooseErrorEffectField="onChooseErrorEffectField"
        />
      </div>
    </el-dialog>
    <back-to-top visibleoffset="200" bottom="50px" right="50px">
      <el-button class="back-to-top-button" type="info" circle>
        <i class="el-icon-caret-top" />
        <div v-text="'顶部'" />
      </el-button>
    </back-to-top>

    <el-drawer
      class='pdf-drawer'
      :visible.sync="pdf.isShowPdf"
      :modal='false'
      :modal-append-to-body='false'
      :wrapperClosable='false'
      size='310px'
      direction="ltr">
      <Pdf :pageNum.sync='pdf.pageNum' :url='fileUrl'></Pdf>
    </el-drawer>

  </div>
</template>

<script>
  import Project from "@/api/project";
  import Tinymce from '@/components/Tinymce'
  import $ from 'jquery'
  import BackToTop from 'vue-backtotop';
  import Pdf from '@/components/Pdf/index'
  import AssetPoolFieldMapper from "./components/AssetPoolFieldMapper";
  import AssetPoolError from "./components/AssetPoolError";

  export default {
    name: 'ProspectusDetail',
    components: { Tinymce, BackToTop, Pdf, AssetPoolFieldMapper, AssetPoolError },
    props: ["reportType"],
    data() {
      return {
        loading: true,
        projectId: null,
        headerTitle: '',
        result: {},
        fileUrl: null,
        projectName: '',
        tabResult: {},
        canEdit: false,
        canView: true,
        isMenuFixed: false,
        // 编辑结果
        editTextFieldDialogVisible: false,
        editHtmlFieldDialogVisible: false,
        fieldType: 'text',
        html: '',
        text: '',
        appendUploadLoading: false,
        // 勾稽关系错误
        showErrors: false,
        errors: [],
        pdf: {
          isShowPdf: false, // 展示pdf
          pageNum: -1
        },
        // ABS资产池统计
        assetPoolDialogVisible: false,
        assetPoolDialogKind: 'field_index_mapping',
        assetPoolDialogTitleMap: {
          field_index_mapping: '修改识别统计字段',
          format_mode: '修改分布统计设置',
          table_detail: '区间设置',
        },
        assetRefreshFlag: 0,
        assetPoolData: {},
        field_index_mapping: {},
        format_type: "左开右闭",
        format_mode: "(a-b（含）]",
        unit: "万元",
        table_detail: {
          field_name: '',
          self_selected_field_name: '', // 仅用于"自选字段"
          max_num: '',
          min_num: '',
          step: '',
          max_num_hint: '0',
          min_num_hint: '999',
          isMultiSteps: false,
          multiSteps: null, // 格式e.g. [[null, 1], [1,4], [4,5], [5,10], [10, null]]
        },
        assetPoolDataLoading: false,
        assetPoolUpdateLoading: false,
        assetPoolError: {},
        assetPoolErrorVisible: false,
      }
    },
    computed: {
      list() {
        // let result = [];
        // let deadlines = {};
        // Object.keys(this.result).forEach(key => {
        //   if (key.endsWith('-截止日')) {
        //     deadlines[key] = this.result[key];
        //   } else {
        //     result.push({
        //       key: key,
        //       col0: key,
        //       col1: this.result[key]
        //     })
        //   }
        // });
        // Object.keys(deadlines).forEach(_key => {
        //   let pos = _key.indexOf('-截止日');
        //   let key = _key.substring(0, pos);
        //   let items = result.filter(i => i.key === key);
        //   if (items.length > 0) {
        //     items[0].deadline = deadlines[_key];
        //   }
        // });
        // return result;
        let keys = [];
        let result = [];
        Object.keys(this.result).forEach(_key => {
          if (_key === '文件URL') {
            this.fileUrl = this.result[_key];
          } else if (_key === '勾稽关系') {
            console.log('>>> :inspect: 勾稽关系 ', );
            if (this.result[_key]['用户填入字段表'] && this.result[_key]['用户填入字段表'].length > 0) {
              let errors = [];
              for (const error of this.result[_key]['用户填入字段表']) {
                let _error = {
                  error_info: error.error_info,
                  error_fields: [],
                  error_type: 'same-table'
                };
                for (const key of error.error_key_list) {
                  let field = {
                    name: key,
                    view: key,
                    // table: this.tableType,
                    canLocate: false,
                    // position: { row: null, col: null }
                  };
                  // if (key in this.keyPosition) {
                  //   field.canLocate = true;
                  //   const position = this.keyPosition[key];
                  //   field.position.row = position.row;
                  //   field.position.col = position.col;
                  // } else {
                  //   console.warn(`${this.tableType} 未知勾稽关系错误科目：${key}，错误：${error}`);
                  // }
                  _error.error_fields.push(field);
                }
                errors.push(_error);
              }
              this.errors = errors;
            }
          } else if (!_key.endsWith('所在页码')) {
            keys.push(_key);
          }
        });
        keys.forEach(key => {
          result.push({
            key,
            col0: key,
            col1: this.result[key],
            page: this.result[key + '所在页码']
          })
        });
        // region 判断勾稽关系错误字段是否可以点击
        this.errors.forEach(error => {
          error.error_fields.forEach(field => {
            // console.log('>>> :inspect: 判断 ', );
            if (keys.indexOf(field.name) >= 0) {
              field.canLocate = true;
            }
          })
        });
        // endregion 判断勾稽关系错误字段是否可以点击
        return result;
      },
      menuTree() {
        let tree = [];
        Object.keys(this.result).forEach(key => {
          if (!key.endsWith('-截止日') && key !== '文件URL' && !key.endsWith("所在页码") && !key.endsWith("勾稽关系")) {
            if (key.length > 14) {
              tree.push({
                key: key,
                label: key.substr(0, 14) + '...'
              })
            } else {
              tree.push({
                key: key,
                label: key
              })
            }
          }
        });
        return tree;
      },
      isTextType() {
        return ["inquiry_name_list", "issue_anc_fields_user_filled"].indexOf(this.reportType) >= 0;
      },
      fixedMenuClass() {
        return {
          'fixed-menu-tree': this.isMenuFixed && this.reportType !== 'asset_pool',
          'asset-pool-fixed-menu-tree': this.isMenuFixed && this.reportType === 'asset_pool'
        }
      },
      fixedToolBarClass() {
        return {
          'asset-pool-action': !this.isMenuFixed && this.reportType === 'asset_pool',
          'fixed-asset-pool-action': this.isMenuFixed && this.reportType === 'asset_pool'
        }
      },
      fieldPlaceholderClass() {
        return {
          'field-place-holder': !this.isMenuFixed && this.reportType === 'asset_pool',
          'asset-pool--place-holder': this.isMenuFixed && this.reportType === 'asset_pool'
        }
      },
      hasAssetPoolError() {
        return JSON.stringify(this.assetPoolError) !== '{}';
      }
    },
    created() {
      this.projectId = this.$route.params.id;
      Project.getProjectInfo({ projectId: this.projectId })
        .then( response => {
          if (this.$store.getters.roles.includes('admin')) {
            if (this.$store.getters.userId === response.wpes_user_id) {
              this.canEdit = true;
            }
          } else {
            this.canEdit = true;
          }
          if (['land_certificate', 'loan_contract', 'credit_report', 'transfer_voucher'].indexOf(response.report_type) >= 0) {
            this.headerTitle = '';
          } else if ([].indexOf(response.report_type) >= 0) {
            // todo: 确定需要显示年份的类型
            this.headerTitle = response.issuer_name + '-' + response.report_year;
          } else {
            this.headerTitle = response.issuer_name;
          }
          this.getParseResult();
          if (response.report_type === "asset_pool") {
            Project.getExtractErrorReport({projectId: this.projectId})
              .then (response => {
                this.assetPoolError = this.adaptAPIAssetPoolError(response);
              })
            Project.getTableUpdateInitData({ projectId: this.projectId})
              .then (response => {
                this.assetPoolData = response;
              })
          }
        })
    },
    mounted() {
      window.addEventListener("scroll", this.handleScroll);
    },
    beforeDestroy() {
      window.removeEventListener("scroll", this.handleScroll);
    },
    methods: {
      getParseResult() {
        Project.getParseResult({ projectId: this.projectId })
          .then(response => {
            this.result = this.adaptAPIGetParseResult(response);
            setTimeout(() => {
              this.loading = false;
            }, 100);
          })
          .catch(error => {
            // todo error不一定是网络错误
            if (error.response && error.response.status === 401) {
              this.canView = false;
              this.loading = false;
            } else {
              this.loading = false;
              console.log(error);
            }
          });
      },
      goBack() {
        this.$router.push({ name: 'ProjectList' });
      },
      htmlCellStyle({ row, rowIndex, column, columnIndex }) {
        if (columnIndex === 1 && row.col1 !== '') {
          return {
            padding: '5px'
          }
        }
      },
      handleScroll() {
        if (this.reportType === 'asset_pool') {
          let rect = this.$refs.assetPoolToolBar.getBoundingClientRect();
          this.isMenuFixed = rect.top - 10 < 0;
        } else {
          let rect = this.$refs.menuTree.getBoundingClientRect();

          this.isMenuFixed = rect.top < 0;
        }
      },
      handleNodeClick(data) {
        // console.log('>>> :inspect: 跳转 data', data);
        document.getElementById(data.key).scrollIntoView({ behavior: "smooth" });
      },
      jumpToField(field) {
        // console.log('>>> :inspect: jumpToField field', field);
        document.getElementById(field).scrollIntoView({ behavior: "smooth" });
      },
      editEvent(row) {
        // console.log(row);
        let isHtml = /<[^>]+>/g.test(row.col1);
        if (isHtml) {
          this.fieldType = 'html';
          this.html = row.col1;
          this.field = row.col0;
          this.appendUploadLoading = false;
          this.editHtmlFieldDialogVisible = true;
          setTimeout(() => {
            window.tinymce.get('vue-tinymce').setContent(this.html || '')
          }, 200);
        } else {
          this.fieldType = 'text';
          this.text = row.col1;
          this.field = row.col0;
          this.appendUploadLoading = false;
          this.editTextFieldDialogVisible = true;
        }
      },
      modifyDistribution(row) {
        this.onClickEditAssetPoolConfig('table_detail', row.col0);
      },
      gotoPage(row) {
        console.log('>>> :inspect: 跳转 row', row);
      },
      //获取table内容并转成二维数组（支持colspan和rowspan）
      getTabArray(jq) {
        let data = [];
        if (jq.find("tr").length == 0) {
          return data;
        }
        //填充数组
        jq.find("tr").each(function () {
          let arr = [];
          $(this).children('th,td').each(function () {
            arr.push($(this).text().trim());
            if ($(this).attr('colspan')) {
              for (let i = 0, len = parseInt($(this).attr('colspan')) - 1; i < len; i++) {
                arr.push('');
              }
            }
          });
          data.push(arr);
        });
        //二次填充
        let yIndex = 0;
        jq.find("tr").each(function () {
          let xIndex = 0;
          $(this).children('th,td').each(function () {
            let t_yIndex = 0;
            if ($(this).attr('rowspan')) {
              t_yIndex = parseInt($(this).attr('rowspan'));
            }

            for (let i = 1, len = t_yIndex; i < len; i++) {
              let arr = data[yIndex + i];
              arr.splice(xIndex, 0, '');
            }

            if ($(this).attr('colspan')) {
              xIndex += parseInt($(this).attr('colspan'));
            } else {
              xIndex++;
            }
          });
          yIndex++;
        });
        return data;
      },
      async saveHtml() {
        try {
          this.appendUploadLoading = true;
          const html = window.tinymce.get('vue-tinymce').getContent();
          const data = {
            projectId: this.projectId,
            period: "first",
            data: {
              values: {}
            }
          };
          // todo 临时直接去掉换行符，疑似编辑器组件插在相邻标签之间
          data.data.values[this.field] = html.replace(/\n/g, '');
          if (this.reportType === 'asset_pool') {
            data.data.values[this.field] = this.getTabArray($(data.data.values[this.field]));
          }
          await Project.updateResult(data);
          this.appendUploadLoading = false;
          this.$message("已更新");
          this.editHtmlFieldDialogVisible = false;
          await this.getParseResult();
        } catch (e) {
          console.log(e);
          this.appendUploadLoading = false;
          this.$message.error("更新失败");
        }
      },
      async saveText() {
        try {
          this.appendUploadLoading = true;
          const data = {
            projectId: this.projectId,
            period: "first",
            data: {
              values: {}
            }
          };
          data.data.values[this.field] = this.text;
          await Project.updateResult(data)
          this.appendUploadLoading = false;
          this.$message("已更新");
          this.editTextFieldDialogVisible = false;

          // todo 待确认哪些需要类型需要更新勾稽关系
          // const updateRelationshipData = {
          //   projectId: this.projectId,
          //   period: "first",
          //   reportType: this.reportType
          // };
          // await Project.updateRelationship(updateRelationshipData);
          await this.getParseResult();
        } catch (e) {
          console.log(e);
          this.appendUploadLoading = false;
          this.$message.error("更新失败")
        }
      },
      insertToDb() {
        Project.prospectusInsert({ projectId: this.projectId })
          .then(response => {
            this.$message.success('数据已经入库');
          })
          .catch(error => {
            console.log(error);
            this.$message.error('数据入库出错！');
          })
      },
      // 展示pdf
      showPdf(field) {
        console.log('>>index', field)
        if (!field.page) {
          return
        }
        this.pdf = {
          isShowPdf: true, // 展示pdf
          pageNum: field.page
        }
      },
      //#region ABS资产池解析
      resetAssetPoolForm() {
        this.assetPoolDialogVisible = false;
      },
      initAssetPoolConfig(assetPoolData, kind, param) {
        this.assetPoolData = assetPoolData;
        this.field_index_mapping = this.assetPoolData.section_info.field_index_mapping;
        console.log('[initAssetPoolConfig this.field_index_mapping]', this.field_index_mapping);
        this.format_mode = this.assetPoolData.section_info.format_mode;
        if (["(a-b（含）]", "(a,b]"].indexOf(this.format_mode) >= 0) {
          this.format_type = "左开右闭";
        }
        if (["[a（含）-b)", "[a,b)"].indexOf(this.format_mode) >= 0) {
          this.format_type = "左闭右开";
        }
        this.unit = this.assetPoolData.section_info.unit;
        if (kind === 'table_detail' || kind === 'table_detail_has_self_selected_field') {
          if (kind === 'table_detail') {
            this.table_detail.field_name = param;
            // 初次打开"自选字段分布"时，先不选任何"自选字段"
            if (this.table_detail.field_name === "用户自选字段分布") {
              this.table_detail.self_selected_field_name = '';
            }
          }
          if (Object.keys(this.assetPoolData.field_section_mapping).indexOf(param) >= 0) {
            this.table_detail.max_num = this.assetPoolData.field_section_mapping[param].current_max_value.toString();
            this.table_detail.min_num = this.assetPoolData.field_section_mapping[param].current_min_value.toString();
            this.table_detail.max_num_hint = this.assetPoolData.field_section_mapping[param].max_value;
            this.table_detail.min_num_hint = this.assetPoolData.field_section_mapping[param].min_value;
            this.table_detail.step = this.assetPoolData.field_section_mapping[param].step.toString();
          } else {
            this.table_detail.max_num = '';
            this.table_detail.min_num = '';
            this.table_detail.max_num_hint = '';
            this.table_detail.min_num_hint = '';
            this.table_detail.step = '';
          }
          this.table_detail.multiSteps = this.customizeSectionToMultiSteps(this.assetPoolData.customize_section, this.table_detail.field_name);
          this.table_detail.isMultiSteps = this.table_detail.multiSteps !== null;
        }
        this.assetRefreshFlag += 1;
      },
      onFormatTypeChange(value) {
        if (value === '左开右闭') {
          this.format_mode = '(a-b（含）]';
        }
        if (value === '左闭右开') {
          this.format_mode = '[a（含）-b)';
        }
      },
      async onClickEditAssetPoolConfig(kind, param) {
        this.assetPoolDataLoading = true;
        this.assetPoolDialogVisible = true;
        try {
          let assetPoolData = await Project.getTableUpdateInitData({ projectId: this.projectId})
          console.log('[onClickEditAssetPoolConfig assetPoolData]', assetPoolData);
          this.initAssetPoolConfig(assetPoolData, kind, param);
          this.assetPoolDialogKind = kind;
          this.assetPoolDataLoading = false;
        } catch ( error ) {
          this.assetPoolDialogVisible = false;
          this.$message.error("获取已有配置出错");
          setTimeout(() => {
            this.assetPoolDataLoading = false;
          }, 500);
          console.log(error);
        }
      },
      async onTableDetailSelfSelectedFieldChange() {
        try {
          let assetPoolData = await Project.getTableUpdateInitData({ projectId: this.projectId});
          this.initAssetPoolConfig(assetPoolData, "table_detail_has_self_selected_field", this.table_detail.self_selected_field_name);
        } catch ( error ) {
          this.$message.error("获取已有配置出错");
          console.log(error);
        }
      },
      onClickUpdateAssetPoolConfig() {
        let configValid = true;
        let update_info = {};

        function toNumber(str) {
          if (str.indexOf('.') > 0) {
            return parseFloat(str)
          } else {
            return parseInt(str);
          }
        }

        if (this.assetPoolDialogKind === 'field_index_mapping') {
          let {valid, field_index_mapping, distribution_form_type_info} = this.$refs.assetPool.getConfig();
          if (valid) {
            this.$message.info("重新解析比较耗时，请耐心等待");
            update_info.field_index_mapping = field_index_mapping;
            update_info.distribution_form_type_info = distribution_form_type_info;
          } else {
            configValid = false;
          }
        } else if (this.assetPoolDialogKind === 'format_mode') {
          update_info.field_index_mapping =  this.field_index_mapping;
          // update_info.distribution_form_type_info = distribution_form_type_info;
          update_info.section_info = {
            format_mode: this.format_mode,
            unit: this.unit,
          }
        } else if (this.assetPoolDialogKind === 'table_detail') {
          let field_name = this.table_detail.field_name;
          if (field_name === '用户自选字段分布') {
            field_name = this.table_detail.self_selected_field_name;
          }
          update_info.section_info = {
            table_detail: {
              field_name,
              max_num: toNumber(this.table_detail.max_num),
              min_num: toNumber(this.table_detail.min_num),
              step: toNumber(this.table_detail.step),
            }
          };
          if (this.table_detail.isMultiSteps) {
            if (this.table_detail.multiSteps === null || this.table_detail.multiSteps.length === 0) {
              configValid = false;
              this.$message.warning('请新增区间');
            } else {
              update_info.section_info.table_detail.customize_section = this.multiStepsToCustomizeSection(field_name, this.table_detail.multiSteps);
              // // 去掉固定步长
              // // 后端返回 detail: "缺少字段"
              // update_info.section_info.table_detail.step = '';
            }
          } else {
            // // 去掉自定义步长
            // update_info.section_info.table_detail.customize_section = [];
          }
        }
        if (configValid) {
          this.assetPoolUpdateLoading = true;
          // console.log('>>> :inspect: update_info ', update_info);
          Project.updateAssetPoolConfig({ projectId: this.projectId, update_info })
            .then(response => {
              this.$message.success('更新资产池解析结果成功');
              this.getParseResult();
              setTimeout(() => {
                this.assetPoolUpdateLoading = false;
                this.assetPoolDialogVisible = false;
              }, 500);
            })
            .catch(error => {
              this.assetPoolUpdateLoading = false;
              this.$message.error('更新资产池解析结果失败');
              console.log(error)
            })
        }
      },
      onClickCancelUpdateAssetPoolConfig() {
        this.assetPoolDialogVisible = false;
      },
      async onClickAssetPoolError() {
        let response = await Project.getExtractErrorReport({projectId: this.projectId});
        this.assetPoolError = this.adaptAPIAssetPoolError(response);
        this.assetPoolErrorVisible = true;
      },
      onChooseErrorEffectField(field) {
        this.jumpToField(field);
        this.assetPoolErrorVisible = false;
      },
      adaptAPIAssetPoolError(response) {
        for (let field in response) {
          ["effect_distribution_field", "effect_total_field", "error_classify"].forEach(key => {
            if(typeof response[field][key] === "string") {
              response[field][key] = [response[field][key]];
            }
          })
        }
        return response;
      },
      adaptAPIGetParseResult(response) {
        if ("用户自选字段分布" in response) {
          response["用户自选字段分布"] = response["用户自选字段分布"].replace(/<p.+?>(.+?)<\/p>/g,
          '<div id="$1" style="width:0;height:0;background-color: pink;position:relative;top:-80px"></div>$1');
        }
        return response;
      },
      canEditRange(fieldName) {
        if (this.reportType === 'asset_pool' && this.assetPoolData.field_section_mapping) {
          return (fieldName in this.assetPoolData.field_section_mapping) || fieldName === '用户自选字段分布';
        } else {
          return false;
        }
      },
      //#endregion ABS资产池解析
      //#region 区间设置
      /**
       * @name: 每一项的左边输入框发生改变
       * @description:
       * @param {Number} val
       * @param {Number } index
       */
      itemLeftNumberChange (val, index) {
        // 如果是第一个区间则不作处理
        if (index === 0) return
        // 自身修改后还需将上一项的第1位同时修改
        this.table_detail.multiSteps[index - 1][1] = val
      },

      /**
       * @name: 每一项的右边输入框发生改变
       * @description:
       * @param {Number} val
       * @param {Number } index
       */
      itemRightNumberChange (val, index) {
        // 如果是最后一个区间则不作处理
        if (index === this.table_detail.multiSteps.length - 1) return
        // 自身修改后还需将下一项的第0位同时修改
        this.table_detail.multiSteps[index + 1][0] = val
      },

      /**
       * @name: 新增区间
       * @description:
       */
      addArea () {
        let min_num = parseFloat(this.table_detail.min_num);
        let max_num = parseFloat(this.table_detail.max_num);
        let defaultStep = (max_num - min_num) / 5;
        if (this.table_detail.multiSteps === null || this.table_detail.multiSteps.length === 0) {
          this.table_detail.multiSteps = [
            [null, min_num],
            [min_num, min_num + defaultStep],
            [min_num + defaultStep, null],
          ]
        } else {
          let last = this.table_detail.multiSteps[this.table_detail.multiSteps.length - 1];
          last[1] = last[0] + defaultStep;
          this.table_detail.multiSteps.push([last[1], null])
        }
      },

      /**
       * @name: 删除区间
       * @description:
       * @param {Array} item
       * @param {Number } index
       */
      delArea (item, index) {
        // 至少两个区间
        if (this.table_detail.multiSteps.length <= 2) return
        // 删除前将前后区间衔接上, 第一个和最后一个不做处理
        if (index !== 0 && index !== this.table_detail.multiSteps.length - 1) {
          this.table_detail.multiSteps[index + 1][0] = this.table_detail.multiSteps[index - 1][1]
        }
        this.table_detail.multiSteps.splice(index, 1)
      },

      customizeSectionToMultiSteps(customizeSection, fieldName) {
        if (customizeSection === null || customizeSection === undefined) {
          return null;
        } else if (fieldName in customizeSection) {
          let ranges = customizeSection[fieldName];
          let multiSteps = [];
          for (let i = 0; i < ranges.length; i++) {
            let range = ranges[i];
            if ( Array.isArray(range)) {
              multiSteps.push(range);
            } else if (i === 0) {
              multiSteps.push([null, range]);
            } else if (i === ranges.length - 1) {
              multiSteps.push([range, null]);
            }
          }
          return multiSteps;
        } else {
          return null;
        }
      },

      multiStepsToCustomizeSection(fieldName, multiSteps) {
        let customizeSection = {};
        let ranges = [];
        for (let i = 0 ;i<multiSteps.length; i++){
          let step = multiSteps[i];
          if (step[0] === null) {
            ranges.push(step[1]);
          } else if (step[1] === null) {
            ranges.push(step[0]);
          } else {
            ranges.push(step);
          }
        }
        customizeSection[fieldName] = ranges;
        return customizeSection;
      }
      //#endregion 区间设置
    }
  }
</script>
<style lang="scss"  scoped>
  .prospectus-container {
    margin: 10px;
  }
  .result-container {
    margin-top: 10px;
  }
  .result {
    display: flex;
    .menu-view {
      flex: 0 0 300px;
      word-break: keep-all; /* 不换行 */
      white-space: nowrap; /* 不换行 */
      overflow: hidden; /* 内容超出宽度时隐藏超出部分的内容 */
      text-overflow: ellipsis;
    }
    .middle {
      flex-grow: 1;
    }
    .right {
      flex-grow: 1;
    }
  }
  .field-title {
    margin-right: 10px;
    background-color: #e4e8f1;
    color: #48576a;
    padding: 3px 5px;
    height: 24px;
    line-height: 22px;
    /*font-size: 12px;*/
    border-radius: 4px;
    box-sizing: border-box;
    /*cursor: pointer;*/
  }
  .field-bar {
    /*position: -webkit-sticky;*/
    /*position: sticky;*/
    top: 0;
    margin: 5px 0;
  }
  .field-content {
    font-size: 12px;
    font-family: -apple-system,BlinkMacSystemFont,Segoe UI,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica Neue,
    Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol;
    color: #606266;
    border: 1px solid;
    padding: 5px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
  }
  .el-tree {
    min-width: 100%;
    display: inline-block;
  }
  .fixed-page-header {
    position: fixed;
    top: 0;
  }
  .fixed-menu-tree {
    position: fixed;
    top: 10px;
  }
  .menu-tree-wrapper {
    overflow-y: scroll;
    /*overflow:auto;*/
    max-height: 500px;
    width:280px;
    /*border: 10px solid rgba(0, 0, 0, .025);*/
    /*background-color: #2ac06d;*/
    border: 1px solid #ebebeb;
    border-radius: 3px;
  }
  .html-action {
    margin-top: 5px;
  }
  .empty-html-action {
    padding: 2px 15px;
    font-size: 12px;
    border-radius: 3px;
  }
  .html-key {
    .key {
      font-size: 14px;
    }
  }
  .deadline {
    .title {
      font-size: 13px;
      color: #626675;
      margin-right: 12px;
    }
    .date {
      font-size: 13px;
      color: #9195a3;
    }
  }
  .insert-action {
    margin: 15px 0;
  }
  .title-text {
    color: #606266;
  }
  .file-link {
    margin-left: 20px;
  }
  .asset-pool-action {
    border-top: 5px solid white;
  }
  .fixed-asset-pool-action {
    position: fixed;
    width: 100%;
    background-color: white;
    top: 0px;
    border-top: 5px solid white;
    border-bottom: 5px solid white;
    border-bottom-color: linear-gradient(-90deg, #FFBA33, #B3450A);
  }
  .asset-pool-fixed-menu-tree {
    position: fixed;
    top: 50px;
  }
  .field-place-holder {
    width: 0;
    height: 0;
    position: relative;
    top: -80px;
  }
  .asset-pool--place-holder {
    width: 0;
    height: 0;
    position: relative;
    top: -50px;
  }
  .asset-pool-fields-container {
    margin: 10px auto;
    .title {
      text-align: center;
    }
  }
  .asset-pool-field-wrapper {
    display: flex;
    width: 80%;
    margin: 5px 0;
    justify-content: space-between;
    align-items: flex-start;
    .field-name-wrapper {
      width: 30%;
      .field-name {
        float: right;
        margin-top: 10px;
        margin-right: 20px;
      }
    }
    .field-selector-wrapper {
      width: 70%;
      display: flex;
      align-items: center;
      .field-selector {
        flex: none;
        width: 340px;
        margin-right: 10px;
      }
      .field-hint {
        font-size: 14px;
        color: #409EFF;
        cursor: help;
      }
      .field-number-hint {
        margin-top: 5px;
        color: #F56C6C;
      }
    }
  }
  .action-next-step {
    width: 500px;
    margin: 10px auto;
    text-align: center;
  }
  .error-header {
    margin-top: 5px;
  }
  .step-type-selector {
    margin: 15px 0;
  }
  .content-box {
    width: 70%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    // width: 50%;
    .content-top {
      span {
        display: inline-block;
        width: 75px;
      }
      .el-select {
        width: 148px;
      }
    }
    .section-area {
      max-height: 350px;
      overflow: auto;
      .section-item {
        display: flex;
        align-items: center;
        margin-top: 18px;
        &:first-child {
          margin-top: 10px;
        }
        i {
          cursor: pointer;
          font-size: 18px;
        }
      }
    }
    .area-input-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 222px;
      margin-right: 10px;
      border-radius: 5px;
      border: 1px solid #dcdfe6;
      box-sizing: border-box;
      ::v-deep .el-input-number--mini {
        width: 80px;
        padding: 0 5px;
      }
      ::v-deep .el-input-number--mini .el-input__inner {
        padding-left: 0;
        padding-right: 0;
      }
      ::v-deep .el-input__inner {
        border: 0px solid #dcdfe6;
      }
      ::v-deep .el-input-number__decrease {
        display: none;
      }
      ::v-deep .el-input-number__increase {
        display: none;
      }
    }
    .add-but {
      width: 222px;
      text-align: center;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #3b71c6;
      line-height: 37px;
      cursor: pointer;
    }
  }
</style>
<style lang='scss'>
.pdf-drawer {
    .el-drawer__body {
      overflow: auto;
    }
  }
</style>
